export const UPLOAD_INITIATE = "UPLOAD_INITIATE";
export const UPLOAD_PROGRESS = "UPLOAD_PROGRESS";
export const UPLOAD_SUCCESS = "UPLOAD_SUCCESS";
export const UPLOAD_FAILURE = "UPLOAD_FAILURE";
export const UPLOAD_FAILURE_CLEAR = "UPLOAD_FAILURE_CLEAR";
